import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import axios from "axios";

const token = localStorage.getItem('authToken');

const ListPackages = () => {
  const [userData, setUserData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [staticData, setStaticData] = useState([]);
  const history = useHistory();

  const fetchPackage = async () => {
    try {
      const response = await axios.get("https://brand.aasmo.in/api/admin/package", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      if (response) {
        setStaticData(response.data); // Assuming response.data contains the array of packages
      } else {
        console.log("Error getting List");
      }
    } catch (error) {
      console.error("Error fetching package data:", error);
    }
  };
  const handleDownloadCSV = () => {
    const headers = [
      'S.No',
      'Title',
      'Description',
      'Price',
      'Start Date',
      'Expiry Date',
      'Status',
    ];
  
    const csvRows = [];
    csvRows.push(headers.join(',')); // Add headers as the first row
  
    staticData.forEach((packageItem, index) => {
      const row = [
        index + 1, // Serial number
        packageItem.title || 'N/A', // Title
        packageItem.description || 'N/A', // Description
        packageItem.price || 'N/A', // Price
        formatDate(packageItem.startDate) || 'N/A', // Start Date
        formatDate(packageItem.endDate) || 'N/A', // Expiry Date
        packageItem.status || 'N/A', // Status
      ];
  
      csvRows.push(row.map(value => `"${value}"`).join(',')); // Add row data, wrapping values in quotes
    });
  
    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = 'packages_list.csv';
    link.click();
  };
  
  
  useEffect(() => {
    fetchPackage();
  }, []);

  const handleEdit = (id) => {
    history.push(`/edit-packages/${id}`);
  };
  const handleStatusChange = async (id, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'Inactive' : 'active';
    try {
      await axios.put(`https://brand.aasmo.in/api/admin/package/${id}`, { status: newStatus }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
      fetchPackage()
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://brand.aasmo.in/api/admin/package/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      // Update the state to remove the deleted package
      setStaticData(staticData.filter(packageItem => packageItem._id !== id));
      setShowModal(false);
    } catch (error) {
      console.error("Error deleting package:", error);
      setShowModal(false); // Close the modal even if there is an error
    }
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Packages</h2>
        </div>
        <div style={{marginLeft:"15px"}}>
       <button onClick={handleDownloadCSV} className="btn btn-primary">
            Download CSV
          </button>
          </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Description</th>
                <th>Price</th>
                <th>Add Deals</th>
                <th>Start Date</th>
                <th>Expiry Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {staticData.map((packageItem, index) => (
                <tr key={packageItem._id}>
                  <td>{index + 1}</td>
                  <td>{packageItem.title}</td>
                  <td>{packageItem.description}</td>
       
                  <td>{packageItem.price}</td>
                  <td>{packageItem?.addDeals}</td>
                  <td>{formatDate(packageItem.startDate)}</td>
                  <td>{formatDate(packageItem.endDate)}</td>
                  <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={packageItem.status === 'active'}
                          onChange={() => handleStatusChange(packageItem._id, packageItem.status)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                  <td>  
                    <i className="icon-pencil" onClick={() => handleEdit(packageItem._id)}></i>
                    &nbsp;&nbsp;
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(packageItem._id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ConfirmDeleteModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleConfirm={() => handleDelete(selectedUserId)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(ListPackages);
